import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import Content from '../../component/ContentWrapper/Content/Content';
import Error from '../../component/ContentWrapper/Content/Error/Error';
import ProtectedRoute from '../../component/Route/ProtectedRoute';

import ContentPage from '../../component/Page/ContentPage';

import { loadDeviceDetails } from './loader/load-device-details';
import { rootLoader } from './loader/root-loader';
import { loadDevices } from './loader/load-devices';
import { authCallbackLoader } from './loader/auth-callback-loader';

import StatisticPage from '../../component/Page/StatisticPage';

import money from '../../assets/img/svg/title/money.svg';
import pulse from '../../assets/img/jpg/health-monitor/health-monitor-title-pulse.png';
import statistics from '../../assets/img/svg/title/statistics.svg';
import { FilterType } from '../../enum/FilterType';
import CashRegisterPage from '../../component/Page/CashRegister/CashRegisterPage';

const HealthMonitor = lazy(() => import('../../component/ContentWrapper/Content/HealthMonitor/HealthMonitor'));
const DeviceDetails = lazy(
  () => import('../../component/ContentWrapper/Content/HealthMonitor/DeviceDetails/DeviceDetails'),
);

export const router = createBrowserRouter([
  {
    path: '/auth/callback',
    loader: authCallbackLoader,
    errorElement: <Error></Error>,
    element: null,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <ContentPage></ContentPage>
      </ProtectedRoute>
    ),
    errorElement: <Error></Error>,
    id: 'root',
    loader: rootLoader,
    children: [
      {
        index: true,
        element: (
          <Content title={'statisticPage.header.title'} filterType={FilterType.NORMAL} icon={statistics}>
            <StatisticPage></StatisticPage>
          </Content>
        ),
      },
      {
        path: 'cash-register',
        element: (
          <Content title={'cashRegister.header.title'} filterType={FilterType.CASH_REGISTER_FILTERS} icon={money}>
            <CashRegisterPage></CashRegisterPage>
          </Content>
        ),
      },
      {
        path: 'health-monitor',
        element: (
          <Content title={'healthMonitor.header.title.deviceList'} icon={pulse}>
            <HealthMonitor></HealthMonitor>
          </Content>
        ),
        loader: loadDevices,
      },
      {
        path: 'health-monitor/:locationName/details/:locationId',
        element: (
          <Content title={'healthMonitor.header.title.deviceDetails'} icon={pulse}>
            <DeviceDetails></DeviceDetails>
          </Content>
        ),
        loader: loadDeviceDetails,
      },
    ],
  },
]);
